import React from 'react';

import '../App.css';

import { useEffect } from 'react';
import { getAppInsights } from '../AppInsights';

import { resetCookieConsentValue } from 'react-cookie-consent';

interface ListPointProps { title: string, text: string };
const ListPoint: React.FC<ListPointProps> = ({ title, text }) => {
    return <li> <b>{title}</b>
        <p>{text}</p>
    </li>;
}

const Main = () => {

    const appInsights = getAppInsights();
    useEffect(() => {
        appInsights?.trackPageView({ name: "Privacy" });
        console.log(resetCookieConsentValue());
    }, []);

    return (
        <>
            <h2>Privacy policy</h2>
            <p>
                <b>Privacy Policy Effective Date:</b> 2025-05-20 <br />
                <b>Company:</b> Unparalleled Development and Consulting Ltd.<br />
                <b>App:</b> Beta Builder<br />
                <b>Website:</b> <a href='https://beta-builder.com'>https://beta-builder.com</a>
            </p>
            <ol>
                <ListPoint title="Introduction" text="Unparalleled Development and Consulting is committed to privacy. Beta Builder does not collect personal information; all data is anonymized and only collected to improve experience." />
                <ListPoint title="Information We Collect" text="Only anonymized analytical data is gathered, such as app or site usage patterns, feature engagement, and device/system details." />
                <ListPoint title="How We Use the Data" text="Anonymized data is used for improving app functionality, refining features, and resolving bugs—never for personal identification." />
                <ListPoint title="Third-Party Services" text="We may use third-party analytics tools that comply with privacy regulations and do not collect personal information." />
                <ListPoint title="Data Security" text="We implement industry-standard security measures to protect anonymized data against unauthorized access or misuse." />
                <ListPoint title="Your Rights & Control" text="Since no personal data is collected, users do not need to manage privacy settings. Contact us for any inquiries." />
                <ListPoint title="Updates to This Policy" text="The policy may be updated periodically. The latest version will be available on our website." />
                <ListPoint title="Contact Information" text="For privacy-related concerns, contact Peter Lorimer at Unparalleled Development and Consulting via email or the website." />
            </ol>

            <p>
                Unparalleled Development and Consulting Attn: Peter Lorimer Email: mvpete (at) unparalleledadventure.com Website: <a href='https://unparalleledadventure.com'>unparalleledadventure.com</a>
            </p>
            <p>But wait... why is this website different than Beta Builders website? Well, because it's expensive to maintain emails to every specific site.
                I'm a lone developer, and I do this as a hobby. If you purchased the app, thank you very much for your support. If not, thank you for your interest and time.
                Have a great day!</p>
            <div><a href='/'>Back</a></div>
        </>
    );
}

export default Main;
